import axios from 'axios';

const apiUrl = process.env.CA_IF_API_URL || '[Env var not set: CA_IF_API_URL]';

axios.defaults.withCredentials = true;

export const get = async (resource, qs, responseType) => {
  let axiosConstuct = {
    method: 'get',
    url: apiUrl + resource,
    params: qs,
    withCredentials: true
  };

  if (typeof responseType !== 'undefined') {
    axiosConstuct['responseType'] = responseType;
  }

  const req = await axios(axiosConstuct);

  return req;
}

export const post = async (resource, data, responseType) => {
  let axiosConstuct = {
    method: 'post',
    url: apiUrl + resource,
    data: data,
    withCredentials: true
  };

  if (typeof responseType !== 'undefined') {
    axiosConstuct['responseType'] = responseType;
  }

  const req = await axios(axiosConstuct);
  return req;
};


export const put = async (resource, data) => {
  const req = await axios({
    method: 'put',
    withCredentials: true,
    url: apiUrl + resource,
    data: data
  });

  return req;
}


export const del = async (resource, data) => {
  const req = await axios({
    method: 'delete',
    withCredentials: true,
    url: apiUrl + resource,
    data: data
  });

  return req;
}